"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInQuery } from "@/lib/actions/admin-dashboard/inquery/post/createInQuery";

const serverCreateInQuery = async ({
  how,
  name,
  address,
  phone,
  description,
}: {
  how: string;
  name: string;
  address: string;
  phone: string;
  description: string;
}) => {
  const response = await createInQuery({ how, name, address, phone, description });
  return response;
};

export const useCreateInQuery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: serverCreateInQuery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inqueries"] });
    },
  });
};
